import moment from "moment";
import {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "../../../../redux/store";
import BarekamButton, {SimpleButtons} from "../../../components/button";
import {useNavigate, useParams} from "react-router-dom";
import {
    NotificationViewBody,
    NotificationViewContainer,
    NotificationViewTitle,
    NotificationViewTitleContent,
    NotificationViewTitleItem
} from "./styled";
import {BarekamIcon, IconVariants} from "../../../components/icon/barekam-icon";
import BarekamText from "../../../components/text";
import {getNotificationById, updateNotificationsById} from "../../../../redux/slices/user-notifications.slice";
import { Message, MessageSections } from "../../../components/message/message";

export const NotificationView = () => {
    const [isReady, setIsReady] = useState<boolean>(false);

    const {notificationId} = useParams();
    const {notificationData} = useAppSelector(state => state.userNotificationsReducer);
    const {languageId} = useAppSelector(state => state.messagesReducer);

    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        Promise.allSettled([
            dispatch(getNotificationById(notificationId ? +notificationId : undefined)),
            dispatch(updateNotificationsById({notificationId: [notificationId ? +notificationId : 0], data: {seen: true}}))
        ]).then(() => setIsReady(true))
    }, [isReady]);

    function navigateBack() {
        navigate('..')
    }
    if (isReady) {
        return (
            <NotificationViewContainer>
                <NotificationViewTitle>
                    <NotificationViewTitleContent>
                        <BarekamButton type={SimpleButtons.LINK} onClick={() => navigateBack()}>
                            <BarekamIcon variant={IconVariants.back} size={{width: '4rem', height: '1rem'}}/>
                        </BarekamButton>

                        <NotificationViewTitleItem>
                            <BarekamText variant={'l'} bold>
                                <Message messageKey={notificationData?.subject} sectionId={MessageSections.MAIN} />
                            </BarekamText>
                            <BarekamText variant={'m'} opaque>
                                {moment(notificationData?.sendDate).format('DD/MM/YYYY, HH:mm')}
                            </BarekamText>
                        </NotificationViewTitleItem>
                    </NotificationViewTitleContent>
                </NotificationViewTitle>

                <NotificationViewBody>
                    <div dangerouslySetInnerHTML={{__html: notificationData?.body[languageId]}}></div>
                </NotificationViewBody>
            </NotificationViewContainer>
        );
    } else {
        return <></>
    }

}
